
import Index from '../pages/index.vue'
import GoodInfo from '../pages/goodInfo.vue'
import OrderList from '../pages/orderList.vue'


const routes = [
  { path: '/', component: Index },
  { path: '/goodInfo', component: GoodInfo },
  { path: '/orderList', component: OrderList },

]
export default routes